module.exports = __webpack_public_path__ + "static/media/plus.32706134.png";